import { calcBaseConfig } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/baseConfig'
import { linkRowFromPoint } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/pointHalo'
import {
  calcTreeData,
  calcBreadcrumbsConfig,
  createSetRootNodeHandler,
  treeTooltipFormatter
} from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/treeChartUtils'
import { CHART_HEIGHT } from '@aytm/app/stats/page/question-views/components/lib/constants'

export const calcSunburstOptions = props => {
  const { answer, answerVariants, colorTheme, ignoreRefs, ignorePercents, chartLoad, setRootNode, width, height } =
    props

  const seriesData = calcTreeData(answerVariants, answer, {
    colorTheme,
    ignoreRefs,
    ignorePercents,
    percentDecimals: props.reportPercentDecimals
  })

  const options = calcBaseConfig({
    chart: {
      animation: false,
      backgroundColor: 'transparent',
      borderWidth: 0,
      margin: [5, 30, 10, 30],
      shadow: false,
      width,
      // without it Highcharts draws its own 400
      height: height || CHART_HEIGHT,
      events: chartLoad ? { load: chartLoad } : undefined
    },
    legend: { useHTML: true },
    navigation: { breadcrumbs: calcBreadcrumbsConfig() },
    plotOptions: {
      sunburst: {
        allowDrillToNode: true,
        allowPointSelect: true,
        animationLimit: 1000,
        dataLabels: {
          enabled: true,
          // Highcharts 11 defaults to 'circular' (textPath) labels, which drop whole left-side
          // arcs and ignore the ellipsis and halo; 'auto' is the tangent layout the legacy
          // engine (v10) rendered with
          rotationMode: 'auto',
          style: {
            fontFamily: 'Ubuntu, Calibri, Segoe, Helvetica, Arial',
            fontSize: '12px',
            lineHeight: '11px',
            textOverflow: 'ellipsis',
            textOutline: 'none',
            textShadow: '#ffffff 0 0 2px'
          }
        },
        minSize: 1
      },
      series: {
        shadow: false,
        states: { hover: { brightness: 0.05 }, inactive: { opacity: 1 } },
        turboThreshold: 0,
        // Hovering a node tints its row in the list below, as a column or a slice does. No outline
        // in this direction: the tooltip already names the node, and `states.hover` above marks it.
        point: {
          events: {
            mouseOut() {
              linkRowFromPoint(this.series?.chart, null)
            },
            mouseOver() {
              linkRowFromPoint(this.series?.chart, this.id)
            }
          }
        }
      }
    },
    series: [
      {
        type: 'sunburst',
        allowDrillToNode: true,
        allowPointSelect: true,
        animationLimit: 1000,
        data: seriesData,
        keys: ['id', 'parent', 'name', 'value', 'color', 'desc', 'last'],
        levels: [
          { level: 1, levelIsConstant: false },
          { level: 2, colorByPoint: true },
          { level: 3, colorVariation: { key: 'brightness', to: -0.5 } },
          { level: 4, colorVariation: { key: 'brightness', to: 0.5 } }
        ],
        name: 'All',
        events: setRootNode ? { setRootNode: createSetRootNodeHandler(setRootNode) } : undefined
      }
    ],
    tooltip: { formatter: treeTooltipFormatter },
    colors: colorTheme
  })

  return { options }
}
